export const isRHDigitalSettingsRoute = (route) => {
    return route?.path?.startsWith('/rhdigital/settings') || route?.path?.startsWith('/rhdigital/corporation-selection');
};

export const withRHDigitalSettingsPrefix = (path) => {
    if (!path || !path.startsWith('/settings')) {
        return path;
    }

    return `/rhdigital${path}`;
};

export const getSettingsRoute = (path, route) => {
    return isRHDigitalSettingsRoute(route) ? withRHDigitalSettingsPrefix(path) : path;
};

export const configureSettingsEntityRoutes = (entity, route) => {
    if (!isRHDigitalSettingsRoute(route) || !entity?.pages) {
        return entity;
    }

    Object.values(entity.pages).forEach((page) => {
        if (Array.isArray(page.route)) {
            page.route = page.route.map(withRHDigitalSettingsPrefix);
        }
    });

    if (entity.menuPath?.startsWith('/settings')) {
        entity.menuPath = withRHDigitalSettingsPrefix(entity.menuPath);
    }

    return entity;
};
